module.exports = __webpack_public_path__ + "img/kairan.ce3f5a62.png";